var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('bread-crumb')],1),_c('AddRoom',{attrs:{"model":_vm.model,"isSending":_vm.isSending,"type":'add'},on:{"Close":_vm.close,"Save":function($event){return _vm.saveRoom()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }